import React from 'react';
export function PortfolioGrid() {
  // Replace these with your actual client projects
  const projects = [{
    id: 1,
    title: 'Kennedy Smith',
    category: 'Candles and scents',
    image: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/leather-tobacco.jpg',
    services: ['Shopify', 'Loyalty', 'CRO']
  }, {
    id: 2,
    title: 'The Nimble Vitner',
    category: 'wine eCommerce',
    image: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/nimble-vitner.webp',
    services: ['Brand Development', 'eCommerce', 'Subscriptions']
  }, {
    id: 3,
    title: 'Peterson House',
    category: 'Commerce7 Build',
    image: 'https://assets.modern-commerce.io/PH%20logo%20for%20website.jpg',
    services: ['Product Development', 'Launch Strategy', 'Shopify']
  }, {
    id: 4,
    title: 'The Lane',
    category: 'wine eCommerce',
    image: 'https://assets.modern-commerce.io/the%20lane.jpg',
    services: ['Brand Identity', 'Packaging', 'Marketing']
  }, {
    id: 5,
    title: "Oliver's Taranga",
    category: 'wine eCommerce',
    image: 'https://assets.modern-commerce.io/Olivers-Taranga-Fiano-scaled.jpg',
    services: ['Shopify Migration', 'Automation', 'Growth']
  }, {
    id: 6,
    title: 'Howard Vineyard',
    category: 'wine eCommerce',
    image: 'https://assets.modern-commerce.io/howard%20vineyard.jpg',
    services: ['Subscription Model', 'CRO', 'Email Marketing']
  }];
  return <section className="pt-0 pb-20 bg-white" data-id="element-157">
      <div className="max-w-[1400px] mx-auto px-6" data-id="element-158">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-159">
          <p className="text-[#8B7355] text-sm font-semibold tracking-[1.5px] uppercase mb-4 font-['Inter']" data-id="element-160">
            Selected Work
          </p>
          <h2 className="text-[#2C2416] text-[clamp(32px,4vw,48px)] font-light tracking-[-2px] font-['Inter'] mb-6" data-id="element-161">
            Brands We've Built With
          </h2>
          <p className="text-[#8B7355] text-lg max-w-2xl mx-auto font-['Inter']" data-id="element-162">
            Over 15 years, we've designed and developed hundreds of ecommerce
            stores. Here's a selection of recent work - migrations, new builds,
            and redesigns across Shopify and wine ecommerce platforms.
          </p>
        </div>
        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-163">
          {projects.map(project => <div key={project.id} className="relative rounded-xl overflow-hidden h-[400px] bg-[#2C2416]" data-id="element-164">
              {/* Image */}
              <img src={project.image} alt={project.title} className="w-full h-full object-cover" data-id="element-165" />
              {/* Gradient Overlay - Always visible */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#2C2416] via-[#2C2416]/20 to-transparent opacity-60" data-id="element-166" />
              {/* Content Overlay */}
              <div className="absolute inset-0 p-8 flex flex-col justify-end" data-id="element-167">
                {/* Title and Category - Always visible */}
                <div data-id="element-168">
                  <h3 className="text-[#FAF7F2] text-2xl font-medium mb-2 font-['Inter']" data-id="element-169">
                    {project.title}
                  </h3>
                  <p className="text-[#D4A574] text-sm font-medium tracking-wide font-['Inter']" data-id="element-170">
                    {project.category}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}